import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import {
  StyledNavbarUserInfo,
  StyledUserOrgsContainer,
  StyledNavbarUserInfoHeader,
} from "../styled/styles";
import { withRouter } from "react-router-dom";
import { CREATE_WORKSPACE, MY_WORKSPACE } from "../../_utils/routes";
import { switchWorkspace } from "../../_actions/authActions";
import { redirect } from "../../_actions/commonAction";
import { accent, lightInactive } from "../styled/variable";
import { getAuthToken } from "../../_utils/common";
import {
  FaUserPlus,
  FaCog,
  FaPlus,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import {
  Box,
  Button,
  Divider,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Portal,
} from "@chakra-ui/react";
import { withTranslation, useTranslation } from "react-i18next";
import {
  BILLING_PLAN_BUSINESS,
  BILLING_PLAN_GROWTH_PLAN,
  BILLING_PLAN_SIMPLIFIED_TRIAL,
  BILLING_PLAN_SMALL_TEAMS,
} from "../details/constants";
const menuStyle = {
  py: 1,
  px: 6,
  color: "gray.100",
  _hover: {
    bg: "none",
    color: "primary.300",
  },
};
const listStyles = {
  mt: -3.5,
  pt: 0,
  background: "brand.grey-darker",
  minW: "260px",
  ml: -3,
};

// :TODO rewrite this whole file
/* based on previous implementation */
const getSubscriptionColor = (subscriptionName, productName) =>
  subscriptionName === BILLING_PLAN_SIMPLIFIED_TRIAL
    ? accent
    : (productName || subscriptionName) === BILLING_PLAN_SMALL_TEAMS
    ? "#68D5FF"
    : (productName || subscriptionName) === BILLING_PLAN_BUSINESS
    ? "#85DE55"
    : (productName || subscriptionName) === BILLING_PLAN_GROWTH_PLAN
    ? "#ff4a98"
    : lightInactive;

/* based on previous implementation */
const getSubscriptionTypeInfo = (subscription, t) => {
  return subscription?.plan
    ? subscription?.plan?.product?.name
    : subscription?.name
    ? subscription?.name
    : subscription?.trial_remaining_days < 0
    ? t("trial_ended_msg.full_access_ended", { ns: "navbar" })
    : subscription?.trial_remaining_days === 0
    ? t("trial_ended_msg.full_access_ends_today", { ns: "navbar" })
    : subscription?.trial_remaining_days === 1
    ? t("trial_ended_msg.full_access_remaining_day_count", {
        ns: "navbar",
        daycount: subscription?.trial_remaining_days,
      })
    : subscription?.trial_remaining_days > 1
    ? t("trial_ended_msg.full_access_remaining_days", {
        days: subscription?.trial_remaining_days,
        ns: "navbar",
      })
    : null;
};

const TldrOrgTitle = (props) => {
  const { t } = useTranslation(["navbar", "common"]);

  return (
    <StyledNavbarUserInfoHeader
      subscriptionColor={getSubscriptionColor(
        props.selectedOrg?.subscription?.name,
        props.selectedOrg?.subscription?.plan?.product?.name
      )}
    >
      <div className="pro-icon">
        <div className="organization-initials">
          {props.selectedOrg?.name.charAt(0)}
        </div>
      </div>
      <div className="user">
        <Text className="company" mb="0.5">
          {props.workspaceName}
        </Text>
        <div className="email navbar-header-item">
          <div className="subscription navbar-header-item">
            {getSubscriptionTypeInfo(props.selectedOrg?.subscription, t)}
            <Text as="span" color="gray.300" fontSize="xs" ml="1">
              {`${
                props.selectedOrg?.members_count
                  ? props.selectedOrg.members_count === 1
                    ? `1 ${t("member", { ns: "common" })}`
                    : props.selectedOrg.members_count +
                      ` ${t("members", { ns: "common" })}`
                  : `1 ${t("member", { ns: "common" })}`
              }`}
            </Text>
          </div>
        </div>
      </div>
      {props.collapsed ? (
        <FaAngleUp color="white" />
      ) : (
        <FaAngleDown color="white" />
      )}
    </StyledNavbarUserInfoHeader>
  );
};

const TldrOrgList = ({ selectedOrgObj, ...props }) => {
  const userRoleInWorkspace = useSelector(
    (state) => state.auth.payload?.user.role
  );
  const onCreateWorkspace = () => {
    props.redirect(CREATE_WORKSPACE, props);
  };
  const { t } = useTranslation(["navbar", "common"]);

  return (
    <>
      <StyledUserOrgsContainer>
        <MenuItem _hover={{ bg: "none" }}>
          <StyledNavbarUserInfo
            subscriptionColor={getSubscriptionColor(
              selectedOrgObj?.subscription?.name,
              selectedOrgObj?.subscription?.plan?.product?.name
            )}
          >
            <div className="pro-icon">
              <div className="organization-initials">
                {selectedOrgObj?.name.charAt(0)}
              </div>
            </div>
            <div className="user">
              <div className="company">{selectedOrgObj?.name}</div>
              <Text className="subscription" as="span">
                {getSubscriptionTypeInfo(selectedOrgObj?.subscription, t)}
              </Text>
              <Text as="span" m="0" fontSize="xs" color="gray.300" ml="1">
                {`${
                  selectedOrgObj?.members_count
                    ? selectedOrgObj?.members_count
                    : 1
                }`}{" "}
                {selectedOrgObj?.members_count === 1
                  ? t("member", { ns: "common" })
                  : t("members", { ns: "common" })}
              </Text>
              <Text fontSize="xs" color="gray.300" maxWidth="175px">
                {t("workspace_current_role", {
                  role: userRoleInWorkspace?.display_name,
                  ns: "common",
                })}
              </Text>
            </div>
          </StyledNavbarUserInfo>
        </MenuItem>
        {props.canInviteMemberToWorkspace && (
          <MenuItem
            onClick={() => {
              props.history.push(MY_WORKSPACE);
            }}
            sx={menuStyle}
            pt="2"
            pb="2"
            pl="8"
            fontSize="sm"
          >
            <Icon as={FaUserPlus} fontSize="md" mr="2" />
            {t("invite")}
          </MenuItem>
        )}
        {props.canViewWorkspaceSettings && (
          <>
            <MenuItem
              sx={menuStyle}
              onClick={() => {
                props.history.push(MY_WORKSPACE);
              }}
              pt="2"
              pb="2"
              pl="8"
              fontSize="sm"
            >
              <Icon as={FaCog} fontSize="md" mr="2" />
              {t("workspace_settings")}
            </MenuItem>
          </>
        )}
        <Divider mt="2" mb="1" />
        {props.orgsJsx}
      </StyledUserOrgsContainer>
      <Divider borderColor="whiteAlpha.100" mt="0" mb="2" />
      <MenuItem
        sx={menuStyle}
        onClick={() => {
          onCreateWorkspace();
        }}
        mb="1"
        pl="3"
      >
        <Icon as={FaPlus} mr="2" />
        {t("create_new_workspace")}
      </MenuItem>
    </>
  );
};

export class TldrNavDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
    };
  }

  onCreateWorkspace = () => {
    this.props.redirect(CREATE_WORKSPACE, this.props);
  };

  onSwitchWorkspace = (currentOrg, selectedOrg) => {
    if (currentOrg !== selectedOrg) {
      this.props.switchWorkspace(selectedOrg, getAuthToken()).then(() => {
        window.location.reload(false);
      });
    }
  };

  handleToggleUserInfo = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const { type, workspacePermissionChecks, t } = this.props;
    const { canViewWorkspaceSettings, canInviteMemberToWorkspace } =
      workspacePermissionChecks;
    const { user, orgs, selectedOrg } = this.props.auth.payload;
    const selectedOrgObj = orgs.find((item) => item.id === selectedOrg);
    const workspaceName = selectedOrgObj?.name || "";
    const orgsJsx = orgs.map((org, i) => {
      return org.id !== selectedOrg ? (
        <div key={org.id}>
          <MenuItem
            onClick={() => this.onSwitchWorkspace(selectedOrg, org.id)}
            color="gray.100"
            _hover={{ bg: "none", color: "primary.300" }}
          >
            <StyledNavbarUserInfo
              subscriptionColor={getSubscriptionColor(
                org?.subscription?.name,
                org?.subscription?.plan?.product?.name
              )}
            >
              <div className="pro-icon">
                <div className="organization-initials">
                  {org.name.charAt(0)}
                </div>
              </div>
              <Box lineHeight="14px" className="user">
                <Text fontWeight="500" fontSize="sm" mb="1">
                  {org.name}
                </Text>
                <Text className="subscription" as="span" mr="1">
                  {getSubscriptionTypeInfo(org?.subscription, t)}
                </Text>
                <Text as="span" m="0" fontSize="xs" color="gray.300">
                  {`${org?.members_count ? org?.members_count : 1}`}{" "}
                  {org?.members_count === 1
                    ? t("member", { ns: "common" })
                    : t("members", { ns: "common" })}
                </Text>
              </Box>
            </StyledNavbarUserInfo>
          </MenuItem>
          {i !== orgs.length - 1 && <Divider my="1" />}
        </div>
      ) : null;
    });

    return (
      <>
        <Menu isLazy autoSelect={false}>
          <MenuButton
            as={Button}
            textAlign="left"
            fontWeight="normal"
            variant="unstyled"
            px={0}
            minH="60px"
          >
            <TldrOrgTitle
              selectedOrg={selectedOrgObj}
              workspaceName={workspaceName}
            ></TldrOrgTitle>
          </MenuButton>
          <Portal>
            <MenuList sx={listStyles} zIndex={1005}>
              <TldrOrgList
                orgsJsx={orgsJsx}
                selectedOrgObj={selectedOrgObj}
                {...{
                  redirect: this.props?.redirect,
                  history: this.props?.history,
                  canViewWorkspaceSettings,
                  canInviteMemberToWorkspace,
                }}
              ></TldrOrgList>
            </MenuList>
          </Portal>
        </Menu>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
});

TldrNavDropdown.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  switchWorkspace: (workspaceId, token) =>
    dispatch(switchWorkspace(workspaceId, token)),
  redirect: (location, props) => dispatch(redirect(location, props)),
});

export default withTranslation(["navbar", "common"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TldrNavDropdown))
);
